import * as React from 'react';

import { controlVariants } from '@/components/ui/control-variants';
import { cn } from '@/lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    controlVariants(),
                    'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
                    className,
                )}
                ref={ref}
                {...props}
            />
        );
    },
);
Input.displayName = 'Input';

export { Input };
